class WPS {

}

(function ($) {
    $(document).ready(function () {

        let $container = $('body');
        let highlight = $container.find('.quote-highlight');

        let sounds = [];

        highlight.each(function () {
            let _self = $(this);
            let url = _self.data('url');
            if (url) {
                let sound = new Howl({
                    src: [url],
                    onpause: function () {
                        _self.removeClass('playing');
                    },
                    onplay: function () {
                        _self.addClass('playing');
                    },
                    onstop: function () {
                        _self.removeClass('playing');
                        console.log('on stop');
                    },
                    onend: function () {
                        _self.removeClass('playing');
                    }
                });
                _self.data('sound', sound);
                sounds.push(sound);

                _self.click(function (e) {
                    e.preventDefault();
                    let _self = $(this);
                    if (_self.hasClass('playing')) {
                        sound.pause();
                    }
                    else {
                        for (let i in sounds) {
                            sounds[i].pause();
                        }
                        sound.play();
                    }
                });
            }
        });
    });
})(jQuery);


// WEBPACK FOOTER //
// ./js/src/wps.js